import Mustache from 'Mustache';
var lazyLoad = require('./lazyload');

var setMobileView = function(){
  var body;
  var articles = [];
  var mobileTarget;
  var initialData;
  var indexType;

  var _init = function(){
    if (_detectMobile() !== true || window.innerWidth > 425){return false;}

    indexType = document.getElementById('index-page').getAttribute('data-index-type');
    body = document.body;
    body.classList.add('is-mobile-view');
    mobileTarget = document.getElementById('mobile-container');
    initialData = mobileTarget.innerHTML;

    body.addEventListener('load', _createMustacheTemplate);
    _createMustacheTemplate();

    window.addEventListener('resize', _onResize);
  };

  var _createMustacheTemplate = function(){
    articles = _getArticles();
    var template = document.getElementById('mobile-article').innerHTML;
    var rendered = '';
    var adIterator = 2;
    var adIds = [];
    Mustache.parse(template);
    var n = 0;

    [].map.call(articles, function(el, i){
      rendered =  rendered + Mustache.render(template, _createSingleArticle(el));

      if(indexType === 'homepage') {
        if (n === 1) {
          var ad = document.getElementById('gam_static_top_alpha_mobile');
          var adHTML = document.getElementById('gam_static_top_alpha_mobile').outerHTML;
          ad.parentNode.removeChild(ad);
          rendered += "<div style='text-align:center;padding:20px 0 15px;'>"+adHTML+"</div>";
        }
        else if (n === 5) {
          rendered += "<div style='text-align:center;padding:20px 0 15px;'>"+document.getElementById('gam_in_content_alpha_mobile').outerHTML+"</div>";
        }
        else if (n === 11) {
          rendered += "<div style='text-align:center;padding:20px 0 15px;'>"+document.getElementById('gam_in_content_alpha_mobile_1').outerHTML+"</div>";
        }
        else if ([17, 23, 29, 35, 41, 47].includes(n)) {

          var adId = 'gam_in_content_alpha_mobile_'+adIterator;
          adIds.push(adId);
          rendered += "<div style='text-align:center;padding:20px 0 15px;'><div id='"+adId+"'></div></div>";
          adIterator++;
        }

        n++;

      } else if(hasIabConsent() && indexType === 'channel') {

        if (i === 1) {

          var ad = document.getElementById('gam_static_top_alpha_mobile');
          var adHTML = document.getElementById('gam_static_top_alpha_mobile').outerHTML;
          ad.parentNode.removeChild(ad);
          rendered += "<div style='text-align:center;padding:20px 0 15px;'>"+adHTML+"</div>";

        } else if (i === 5) {

          rendered += "<div style='text-align:center;padding:20px 0 15px;'>" +
              "    <div id='gam_static_mid_alpha_mobile'>\n" +
              "      <script>\n" +
              "        googletag.cmd.push(function() {googletag.display('gam_static_mid_alpha_mobile');});\n" +
              "      </script>\n" +
              "    </div>" +
              "</div>";

        } else if (i === 11) {

          rendered += "<div style='text-align:center;padding:20px 0 15px;'>" +
              "    <div id='gam_static_bot_alpha_mobile'>\n" +
              "      <script>\n" +
              "        googletag.cmd.push(function() {googletag.display('gam_static_bot_alpha_mobile');});\n" +
              "      </script>\n" +
              "    </div>" +
              "</div>";

          adIterator++;

        }
      }
    });

    mobileTarget.innerHTML = rendered;

    if(hasIabConsent() && indexType === 'homepage') {
      [].map.call(adIds, function (adId, i) {
        googletag.cmd.push(function () {
          var gam_in_content_alpha_mobile_2 = googletag.defineSlot('/21759686865/Emerce/Emerce_home_in-content_alpha', gam_mobile_sizes, adId).defineSizeMapping(gam_mobile_mapping).addService(googletag.pubads());
          googletag.display(adId);
        });
      });
    }

    body.classList.add('is-mobile-view--done');
    lazyLoad.init();
  };

  var _createSingleArticle = function(article){
    var post = {
      url: article.getElementsByTagName('a')[0].href,
      title: article.getElementsByTagName('h2')[0].innerText,
      channel: 'innovatie',
      date: article.dataset.createtime,
      cleanDate: article.dataset.cleandate,
      imageSrc: article.querySelector('[data-src]').dataset.src,
      author: article.dataset.author
    };

    return post;
  }

  var _getArticles = function(){
    var sidebarArticleContainer = document.querySelector('.m-container-aside') || document.querySelector('.m-channel-aside-articles');
    var mainArticleContainer = document.querySelector('.m-container-content');
    var mainArticles = [];
    var sidebarArticles = [];
    if (mainArticleContainer) {
      mainArticles = [].slice.call(mainArticleContainer.querySelectorAll('article[data-createtime]'));
    }

    if (sidebarArticleContainer) {
      sidebarArticles = [].slice.call(sidebarArticleContainer.querySelectorAll('article[data-createtime]'));
    }

    var articles = [].concat(mainArticles, sidebarArticles);
    articles.sort((a, b) => b.dataset.createtime - a.dataset.createtime);

    return articles;
  };

  var _detectMobile = function(){
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return isMobile;
  }

  var _onResize = function(){
    if (window.innerWidth > 425) {
      mobileTarget.innerHTML = initialData;
      body.classList.remove('is-mobile-view');
      body.classList.remove('is-mobile-view--done');
    }
  };

  return{
    init: _init
  };

}();

if (document.getElementById('index-page')) {
  setMobileView.init();
}
